import React from "react";
import { Link } from "react-router-dom";
import { APP_DOMAIN } from '../../core/utils/config';
import { Container, Logo } from "../../design-system";
import { LinkedInIcon, InstagramIcon, TikTokIcon } from "../../design-system/icons";
import { brandColors } from "../../design-system/tokens";

const Footer = () => {
  return (
    <footer className="bg-white dark:bg-dark-900 border-t border-slate-200 dark:border-dark-800 transition-colors duration-300">
      <Container size="7xl" className="py-12">
        <div className="flex flex-col space-y-6 md:grid md:grid-cols-3 md:items-center md:space-y-0">
          {/* Mobile: Logo and Legal Links in same row, Desktop: Brand in left column */}
          <div className="flex flex-col items-center text-center space-y-4 md:space-y-0 md:flex-row md:items-center md:text-left md:justify-start">
            <Link to="/" className="flex items-center">
              <Logo 
                iconSize="w-6 h-6" 
                textSize="text-xl" 
                useCurrentColor={false}
                iconColor="#3b82f6"
                textColor={brandColors.gradientText}
              />
            </Link>
            {/* Links on mobile - shown here, hidden on desktop */}
            <div className="md:hidden w-full flex flex-wrap justify-center gap-x-4 gap-y-2 text-sm mt-4">
              <Link 
                to="/blog"
                className="text-slate-500 dark:text-dark-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200 font-medium"
              >
                Blog
              </Link>
              <Link 
                to="/privacy"
                className="text-slate-500 dark:text-dark-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200 font-medium"
              >
                Privacy Policy
              </Link>
              <Link 
                to="/terms"
                className="text-slate-500 dark:text-dark-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200 font-medium"
              >
                Terms of Use
              </Link>
            </div>
          </div>

          {/* Links - hidden on mobile, shown on desktop */}
          <div className="hidden md:flex md:flex-wrap justify-center gap-x-8 gap-y-2">
            <Link 
              to="/blog"
              className="text-slate-500 dark:text-dark-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200 font-medium"
            >
              Blog
            </Link>
            <Link 
              to="/privacy"
              className="text-slate-500 dark:text-dark-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200 font-medium"
            >
              Privacy Policy
            </Link>
            <Link 
              to="/terms"
              className="text-slate-500 dark:text-dark-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200 font-medium"
            >
              Terms of Use
            </Link>
          </div>

          {/* Social Media Icons */}
          <div className="flex items-center justify-center md:justify-end space-x-4">
            <a
              href="https://www.linkedin.com/company/myvitae-ai"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 text-slate-400 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-blue-50 dark:hover:bg-dark-800 rounded-full transition-all duration-200"
              title="LinkedIn"
            >
              <LinkedInIcon size="md" />
            </a>
            <a
              href="https://www.instagram.com/myvitae.ai/"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 text-slate-400 hover:text-pink-600 dark:hover:text-pink-400 hover:bg-pink-50 dark:hover:bg-dark-800 rounded-full transition-all duration-200"
              title="Instagram"
            >
              <InstagramIcon size="md" />
            </a>
            <a
              href="https://www.tiktok.com/@myvitae.ai?lang=en"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 text-slate-400 hover:text-slate-900 dark:hover:text-white hover:bg-slate-100 dark:hover:bg-dark-800 rounded-full transition-all duration-200"
              title="TikTok"
            >
              <TikTokIcon size="md" />
            </a>
          </div>
        </div>

        {/* Company ownership and copyright */}
        <div className="mt-8 pt-8 border-t border-slate-200 dark:border-dark-800 text-center">
          <p className="mb-2 text-sm text-slate-700 dark:text-dark-200">
            MyVitae is owned and operated by <span className="font-semibold">Vitae AI LLC</span>.
          </p>
          <p className="text-slate-500 dark:text-dark-400 text-sm">
            © {new Date().getFullYear()} {APP_DOMAIN}. All rights reserved.
          </p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
